import { render, staticRenderFns } from "./Couples.vue?vue&type=template&id=867bb3da&lang=pug&"
import script from "./Couples.vue?vue&type=script&lang=js&"
export * from "./Couples.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports